import { ArrowL12, ArrowR12 } from '@cian/ui-kit/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './VerticalSmallArrow.css';

import type { TDirection } from '@cian/frontend-newbuilding-carousel-component';

export interface IVerticalSmallArrowProps {
  direction: TDirection;
  offset?: number;
  containerClass?: string;
  positionTop?: string;
  onClick?(): void;
}

const DEFAULT_OFFSET = -14;
const DEFAULT_POSITION_TOP = '50%';

export function VerticalSmallArrow({
  direction,
  offset = DEFAULT_OFFSET,
  containerClass,
  onClick,
  positionTop = DEFAULT_POSITION_TOP,
}: IVerticalSmallArrowProps) {
  const ArrowIcon = direction < 0 ? ArrowL12 : ArrowR12;
  const style = direction < 0 ? { left: `${offset}px`, top: positionTop } : { right: `${offset}px`, top: positionTop };

  return (
    <div className={classNames(styles['arrow'], containerClass)} style={style} onClick={onClick}>
      <ArrowIcon color={'gray_icons_100'} />
    </div>
  );
}
